import ChatMessage from './ChatMessage';
import ChatRecipients from './ChatRecipients';
import InputBox from './InputBox';
import { getStore } from '../store/chatStore';
import { observer } from 'mobx-react';
import * as React from 'react';

@observer
export default class UcmaChatView extends React.Component<{}, {}> {
    render() {
        const store = getStore();
        const chat = store.chats[store.chats.length - 1]; // TODO: Support multiple chat
        return chat ? (
            <div>
                <ChatRecipients recipients={chat.recipients} />
                {chat.messages.map(message => (
                    <ChatMessage chatMessage={message} key={message.sequence} />
                ))}
                <InputBox chat={chat} />
            </div>
        ) : null;
    }
}
